import { render, staticRenderFns } from "./recapBudget.vue?vue&type=template&id=31f443db"
import script from "./recapBudget.vue?vue&type=script&lang=js"
export * from "./recapBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports